import { useState, useEffect } from 'react'
import { Box, Typography, useMediaQuery, Card, Divider, Skeleton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'

const ReinviteDataTable = ({ staffData, data, setData }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [checkAll, setCheckAll] = useState(false)

  const handleCheck = (event) => {
    const { value, checked } = event.target

    if (checked) {
      setData([...data, value * 1])
    } else {
      setData(data.filter((item) => item !== value))
    }
  }

  const selectAll = (e) => {
    const { checked } = e.target
    const collection = []

    if (checked) {
      for (const category of staffData) {
        collection.push(category.id)
      }
    }

    setData(collection)
    setCheckAll(checked)
  }

  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 2000)
  }, [])

  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          height: 45,
          backgroundColor: 'gray-background.main',
          display: 'flex',
          px: 1,
          alignItems: 'center',
          overflowX: 'auto',
          overflowY: 'hidden',
          borderTop: '1px solid',
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderColor: 'gray-line.main',
          borderRadius: '4.5px 4.5px 0 0',
        }}
      >
        <AdxFormControlLabel
          label={
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ minWidth: '400px', marginLeft: 2 }} alignItems={'center'}>
                <Typography variant="subtitle1" color="dark-gray-text.main">
                  Staff Name
                </Typography>
              </Box>

              <Box sx={{ minWidth: '200px', marginLeft: 10 }}>
                <Typography variant="subtitle1">Email</Typography>
              </Box>
            </Box>
          }
          control={
            <AdxCheckbox
              onChange={selectAll}
              indeterminate={data.length !== staffData?.length && data.length !== 0}
              checked={(data.length !== 0 && checkAll) || data.length === staffData.length}
            />
          }
        />
      </Box>
      <Box
        variant="outlined"
        sx={{
          backgroundColor: 'white.main',
          width: '100%',
          maxHeight: '300px',
          overflow: 'auto',
          borderRadius: '0 0 4.5px 4.5px',
          border: 1,
          borderColor: 'gray-line.main',
        }}
        className="scrollbar"
      >
        {staffData &&
          staffData?.map((item, index) => (
            <Box key={index}>
              {isLoading ? (
                matches ? (
                  <>
                    <Box width={'100%'} display={'flex'}>
                      <Box p={2} mr={6}>
                        <Skeleton height={30} width={150} />
                      </Box>
                      <Box p={2} mr={6}>
                        <Skeleton height={30} width={150} />
                      </Box>
                      <Box p={2} mr={6}>
                        <Skeleton height={30} width={150} />
                      </Box>
                    </Box>
                    <Divider light />
                  </>
                ) : (
                  <>
                    <Box display={'flex'} flexDirection={'row'} width="100%">
                      <Box p={2} width="50%">
                        <Skeleton height={50} width={'100%'} />
                      </Box>
                      <Box p={2} width="50%">
                        <Skeleton height={50} width={'100%'} />
                      </Box>
                    </Box>

                    <Divider light />
                  </>
                )
              ) : (
                <>
                  <Box py={1} px={1} key={index} display={'flex'} alignItems={'center'}>
                    <AdxFormControlLabel
                      label={
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                          <Box sx={{ minWidth: '400px', marginLeft: 2 }} alignItems={'center'}>
                            <Typography variant="subtitle1" color="dark-gray-text.main">
                              {item.name}
                            </Typography>
                          </Box>

                          <Box sx={{ minWidth: '200px', marginLeft: 10 }}>
                            <Typography variant="subtitle1">{item.work_email}</Typography>
                          </Box>
                        </Box>
                      }
                      control={
                        <AdxCheckbox
                          value={item.id}
                          checked={data.includes(item.id)}
                          onChange={handleCheck}
                        />
                      }
                    />
                  </Box>
                  <Divider light />
                </>
              )}
            </Box>
          ))}
      </Box>
    </Box>
  )
}

export default ReinviteDataTable
